import {
  Dashboard,
  Widget,
} from '@trustero/trustero-api-web/lib/dashboard/dashboard_pb'

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
export function sortByEmitter(dataPoints: any): any {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return dataPoints.sort((a: any, b: any) => a.emitter.localeCompare(b.emitter))
}

export function getSections(
  dashboard: Dashboard,
  frameworkFilters?: string[],
): Section[] {
  const config = JSON.parse(dashboard.getConfiguration())
  const sections = config['sections']
  const sectionWidget = new Map<string, Section>()
  for (const section of sections) {
    sectionWidget.set(section, new Section(section))
  }

  for (const widget of dashboard.getWidgetsList()) {
    const [section, type] = widget.getName().split('/', 2)
    const s = sectionWidget.get(section)
    switch (type) {
      case 'recent':
        s?.setRecent(widget)
        break
      case 'historical':
        s?.setHistorical(widget)
        break
      case 'combined_historical':
        s?.setCombinedHistorical(widget)
        break
    }
  }
  let sectionsList = [...sectionWidget.values()]
  if (frameworkFilters?.length) {
    sectionsList = sectionsList.filter((section) =>
      frameworkFilters.includes(section.getName()),
    )
  }
  return sectionsList
}

export class Section {
  name: string
  recent: Widget | undefined
  historical: Widget | undefined
  combinedHistorical: Widget | undefined

  constructor(name: string) {
    this.name = name
  }

  getName(): string {
    return this.name
  }

  setRecent(value: Widget): void {
    this.recent = value
  }

  setHistorical(value: Widget): void {
    this.historical = value
  }

  setCombinedHistorical(value: Widget): void {
    this.combinedHistorical = value
  }

  getNameForRecent(): string {
    return this.recent === undefined ? '' : this.recent?.getName()
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getDataForRecent(): any {
    if (this.recent == undefined) {
      return []
    }
    const data = JSON.parse(this.recent.getData())
    return data
  }

  getTimeBucketForRecent(): string {
    if (this.recent == undefined) {
      return ''
    }
    const config = JSON.parse(this.recent.getConfiguration())
    return config['time_bucket']
  }

  getNameForHistorical(): string {
    return this.historical === undefined ? '' : this.historical?.getName()
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getDataForHistorical(): any {
    if (this.historical == undefined) {
      return []
    }
    const data = JSON.parse(this.historical.getData())
    return data
  }

  getTimeBucketForHistorical(): string {
    if (this.historical == undefined) {
      return ''
    }
    const config = JSON.parse(this.historical.getConfiguration())
    return config['time_bucket']
  }

  getNameForCombinedHistorical(): string {
    return this.combinedHistorical === undefined
      ? ''
      : this.combinedHistorical?.getName()
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getDataForCombinedHistorical(): any {
    if (this.combinedHistorical == undefined) {
      return []
    }
    const data = JSON.parse(this.combinedHistorical.getData())
    return data
  }

  getTimeBucketForCombinedHistorical(): string {
    if (this.combinedHistorical == undefined) {
      return ''
    }
    const config = JSON.parse(this.combinedHistorical.getConfiguration())
    return config['time_bucket']
  }
}
